// extracted by mini-css-extract-plugin
export default {"wrapper":"wga-z","play":"xga-z"};